import React, { useState } from 'react'

import FaqAccordion from './FaqAccordion'
import { triggerHiFiveClevertap } from './hiFiveClevertap'
import { getWalletUrl } from '../../utils/walletUtils'

const FAQ = ({
  rewardAmount,
  requiredSignUpCountHiFIve,
  expiryTime,
  cycleLength
}) => {
  const walletUrl = getWalletUrl()

  const faqs = [
    {
      title: 'Who can give me a Hi-Five to earn rewards?',
      msg: `Your friends who don't have an account on Cleartrip can give you a Hi-Five by signing up with your referral link. You will receive a reward once any of them signs up. At a time, a maximum of ${requiredSignUpCountHiFIve} of your friends can sign up using your referral link.`
    },
    {
      title: 'Is there any time limit for signing up?',
      msg: `Yes, your friends need to sign up within ${Math.round(expiryTime / 24)} days of you starting the timer. Sign-ups after the timer runs out won't be considered.`
    },
    {
      title: `What happens if the timer runs out before ${requiredSignUpCountHiFIve} friends sign up?`,
      msg: `You'll get a reward for each friend who signs up, but you won't get a reward for the friends who don't sign up before the timer ends. However, you can still earn rewards after ${cycleLength} days by starting a new Hi-Five timer.`
    },
    {
      title: 'How do I check my wallet balance?',
      msg: (
        <p>
          To check your wallet balance,{' '}
          <a href={walletUrl} style={{ color: '#36c' }}>
            click{' '}
          </a>
          here.
        </p>
      )
    },
    {
      title: 'How do I use the wallet balance?',
      msg: 'You can use the wallet balance by selecting the Cleartrip Wallet payment option when booking flights and hotels on Cleartrip.'
    },
    {
      title: 'Where can I use my wallet balance? Does the wallet balance have a validity?',
      msg: 'You can use the wallet balance for booking flights and hotels on Cleartrip. Rewards obtained through Hi-Fives are valid for one year.'
    }
  ]
  const faqHeader = 'Frequently Asked Questions'
  const [currActive, setCurrActive] = useState(-1)
  const [faqViewed, setFaqviewed] = useState(false)

  const handleCleverTap = () => {
    if (faqViewed === false) {
      triggerHiFiveClevertap(
        {
          action_name: "Hi5_FAQ's viewed",
        }
      )
    }

    setFaqviewed(true)
  }
  return (
    <React.Fragment>
      <p className="fs-20 pt-8 pb-4 lh-28 fw-600">{faqHeader}</p>
      <ul style={{ width: '734px' }}>
        {faqs.map((faq, index) => {
          return (
            <li onClick={handleCleverTap}>
              <FaqAccordion
                title={faq.title}
                msg={faq.msg}
                noBottomBorder={index === faqs.length - 1}
                index={index}
                currActive={currActive}
                setCurrActive={setCurrActive}
              />
            </li>
          )
        })}
      </ul>
    </React.Fragment>
  )
}

export default FAQ
